export const links = [
  {
    href: "mailto:kenyokokawa@gmail.com",
    label: "E-mail",
  },
  {
    href: "https://github.com/kenyokokawa",
    label: "GitHub",
  },
  {
    href: "https://www.linkedin.com/in/ken-yokokawa/",
    label: "LinkedIn",
  },
  {
    href: "https://www.strava.com/athletes/9966064",
    label: "Strava",
  },
];
